import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './ReservesRow.module.css';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';

interface ReservesHeaderProps {
  helmet: HeaderHelmetProps;
  showPercentPointChange?: boolean;
  showDollarChange?: boolean;
}

export default function ReservesHeader({
  helmet,
  showPercentPointChange,
  showDollarChange
}: ReservesHeaderProps) {
  const { showBenchmark, year } = useContext(AppContext);

  return (
    <div
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}
      data-testid="reserves-row-header">
      <HeaderHelmet {...helmet} />
      <h5 className="column_align_right" aria-hidden={!showPercentPointChange}>
        {showPercentPointChange ? '%/Pt. Change' : ''}
      </h5>
      <h5 className="column_align_right" aria-hidden={!showDollarChange}>
        {showDollarChange ? '$ Change' : ''}
      </h5>
      <h5 aria-hidden="true"></h5>
      <h5 aria-hidden="true"></h5>
      <h5 className="column_align_right">{year} YE Reserves</h5>
      <h5 className="column_align_right">{year - 1} YE Reserves</h5>
      <h5 className="column_align_right">1-yr Development</h5>
      <h5 className="column_align_right">% of PHS {year - 1}</h5>
      <h5 className="column_align_right">2-yr Development</h5>
      <h5 className="column_align_right">% of PHS {year - 2} </h5>
    </div>
  );
}
